module.exports = __webpack_public_path__ + "img/img2.1e440480.jpg";